"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const constants_1 = __importStar(require("@/constants"));
const styles_1 = __importDefault(require("./styles"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const ProcessQuestionItem = ({ index, onClick, unlocked, completed, questions, activeQuestions, questionsId, }) => {
    const active = (activeQuestions === null || activeQuestions === void 0 ? void 0 : activeQuestions.id) === questionsId;
    let image = null;
    let alt = 'null';
    if (completed) {
        image = constants_1.Images.check;
        alt = 'check';
    }
    if (!completed && !unlocked) {
        image = constants_1.Images.lock;
        alt = 'lock';
    }
    return (core_1.jsx("div", { onClick: onClick, role: "button", tabIndex: index, "aria-label": "Process Question Item", onKeyPress: e => {
            if (e.key === 'Enter') {
                onClick();
            }
        }, className: styles_scss_1.default.questionItem, css: styles_1.default.questionItem(active) },
        core_1.jsx("div", { className: styles_scss_1.default.questionItemLeftCont },
            core_1.jsx("img", { className: styles_scss_1.default.bookIcon, src: active || completed ? constants_1.Images.bookIconActive : constants_1.Images.bookIcon, alt: "book icon" })),
        core_1.jsx("div", { className: styles_scss_1.default.questionItemCenterCont },
            core_1.jsx("label", { css: styles_1.default.questionItemLabel(unlocked) }, constants_1.default.program.processQuestions),
            core_1.jsx("small", { css: styles_1.default.questionItemSmall(unlocked) }, constants_1.default.program.questionsCount(questions === null || questions === void 0 ? void 0 : questions.length))),
        core_1.jsx("div", { className: styles_scss_1.default.questionItemRightCont }, (completed || (!completed && !unlocked)) && (core_1.jsx("img", { css: styles_1.default.rightIcon(completed), src: image, alt: alt })))));
};
ProcessQuestionItem.defaultProps = {
    unlocked: false,
    completed: false,
    activeQuestions: null,
};
exports.default = ProcessQuestionItem;
